import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

import { take, tap } from 'rxjs';

import { TmtLoggerService } from 'tmt-logger';

import { TargetEnvironment } from 'src/environments/environment.interfaces';
import { FileMetadata } from 'src/models/fileMetadata';
import { FileService } from 'src/services/file.service';
import { File } from 'src/models/file';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-attachments',
	templateUrl: './attachments.component.html',
	styleUrls: ['./attachments.component.scss'],
})
export class AttachmentsComponent implements OnInit {
	constructor(
		private loggerService: TmtLoggerService,
		private fileService: FileService,
	) {}

	dataSourceFiles;

	attachments: File[];

	baseUrl = environment.baseurl;

	environment = environment.environment;

	TargetEnvironment = TargetEnvironment;

	/**
	 * Columns shown in the file list. The Import time column is omitted when hideImportTime is set
	 * (migrated files have a misleading import time). Computed as a getter so it reacts to the input
	 * being set asynchronously after the component initializes.
	 */
	get displayedColumnsForFiles(): string[] {
		return this.hideImportTime ? ['name'] : ['name', 'importTime'];
	}

	@ViewChild(MatSort) sort: MatSort;

	/**
	 * Input list of files to display.
	 */
	@Input({ required: true }) files: FileMetadata[];

	/**
	 * When true, hides the Import time column. Used when the file was migrated rather than
	 * genuinely imported, so its import time would be misleading (the migration date).
	 */
	@Input() hideImportTime = false;

	/**
	 * Initialize table data source of files on init.
	 */
	ngOnInit(): void {
		this.dataSourceFiles = new MatTableDataSource<File>(
			this.files.map(item => {
				return {
					Uid: item.FileUid,
					Name: item.FileName,
					ImportTime: item.CreateDate,
					FileStream: '',
				};
			}),
		);
		this.dataSourceFiles.sort = this.sort;
	}

	public applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSourceFiles.filter = filterValue.trim().toLowerCase();
	}

	/**
	 * Fetches a file, then prompts browser to download it to device.
	 * @param fileUid UID of file to download.
	 * @param fileName Name of file to download
	 */
	public downloadFile(fileUid: string, fileName?: string): void {
		this.fileService
			.getFileByFileUid$(fileUid, fileName)
			.pipe(
				tap(file => this.fileService.downloadFile(file)),
				take(1),
			)
			.subscribe();
	}
}
